'use client';
import React, { useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

export default function AxiosProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401 || error.response?.status === 403) {
          // Unauthorized or Forbidden - likely token expired, invalid, or session lost on restart
          if (typeof window !== 'undefined') {
            sessionStorage.clear(); // Clear everything
            window.location.href = '/sign-up-login-screen';
          }
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, []);

  return <>{children}</>;
}
